export default __webpack_public_path__ + "static/bncff-next-image-78800bd5ae1d1eec9ae8f1bd76f1754a.jpg";